/* eslint-disable import/prefer-default-export */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQiSsLXgvbe4CSYqyLdxVjpA9U5S0yR5U",
  appId: "1:880263912879:web:d7934ccd04bb712939635a",
  authDomain: "hammyflip-a87a2.firebaseapp.com",
  measurementId: "G-G7MCZYZ790",
  messagingSenderId: "880263912879",
  projectId: "hammyflip-a87a2",
  storageBucket: "hammyflip-a87a2.appspot.com",
};

// See this link for available libraries
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const firebaseAuth = getAuth(app);

// Initialize Analytics
export const firebaseAnalytics = getAnalytics(app);

// Initialize Firebase Storage
export const firebaseStorage = getStorage(app);
